<template>
  <div class="list-box" v-show="display">
    <div v-if="loading" class="loading-box">
      <img v-if="loading" src="@/assets/icon/ic_loading.svg" class="el-icon-loading loading" />
    </div>
    <div v-else class="content">
      <slot v-if="!empty"></slot>
      <slot v-else name="empty"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    empty: Boolean,
    loading: Boolean,
    display: Boolean
  }
}
</script>

<style lang="scss" scoped>
.list-box {
  .loading-box {
    height: calc(100vh);
    border-radius: 4px;
    box-shadow: 0 10px 20px 0 rgba(69, 73, 91, 0.08);
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    .loading {
      width: 78px;
      height: 78px;
    }
  }
}
</style>
